import {BaseModuleProps} from "../../../../../infrastructure/models/props/base-module-props";
import {CurrentOddsModuleController} from "../current-odds-module.controller";

export class CurrentOddsModuleProps extends BaseModuleProps {
  controller: CurrentOddsModuleController;
}
